import { render } from "./SzLists.vue?vue&type=template&id=dba4dd72&scoped=true"
import script from "./SzLists.vue?vue&type=script&lang=ts"
export * from "./SzLists.vue?vue&type=script&lang=ts"

import "./SzLists.vue?vue&type=style&index=0&id=dba4dd72&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-dba4dd72"

export default script